import { Phone, MessageCircle, Mail } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { HomeCareLogoIcon } from "@/components/HomeCareLogoIcon";

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1A2332] text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-3">
            <HomeCareLogoIcon className="h-12 w-auto" />
            <div className="flex flex-col leading-tight">
              <span className="font-['Playfair_Display'] text-lg font-bold text-white tracking-tight">
                Caceres
              </span>
              <span className="text-[10px] font-semibold text-[#C89D4B] uppercase tracking-[0.2em]">
                Essential Care
              </span>
            </div>
          </div>

          <div className="text-center">
            <p className="text-[#C89D4B] text-sm font-medium mb-1">{t.footer.tagline}</p>
            <p className="text-white/50 text-xs">
              &copy; 2025 Caceres Essential Care. {t.footer.rights}
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="tel:+16093153943"
              className="w-10 h-10 bg-white/10 hover:bg-[#C89D4B] rounded-full flex items-center justify-center transition-colors"
              data-testid="footer-phone"
            >
              <Phone className="w-5 h-5" />
            </a>
            <a
              href="https://wa.me/16093153943"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 bg-white/10 hover:bg-[#C89D4B] rounded-full flex items-center justify-center transition-colors"
              data-testid="footer-whatsapp"
            >
              <MessageCircle className="w-5 h-5" />
            </a>
            <a
              href="mailto:servicies@caceres-essentialcare.com"
              className="w-10 h-10 bg-white/10 hover:bg-[#C89D4B] rounded-full flex items-center justify-center transition-colors"
              data-testid="footer-email"
            >
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
